import {UnsavedChangePrompt} from "./UnsavedChangePrompt";

export const PromptType = {
    unsaved_changes: 'unsaved_changes',
    access_denied: 'access_denied',
};

export function getPrompt(message, callback) {
    switch (message) {
        case PromptType.unsaved_changes:
            return UnsavedChangePrompt(callback);
            // case PromptType.access_denied:
            //   return callback(false)
        default:
            return null;
    }
}
